import { useTranslation } from 'react-i18next'

import { Box, Divider, Paper, Stack, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreateLicenseForm from './containers/CreateLicenseForm'

export default function CreateLicensePage() {
  const { t } = useTranslation()
  return (
    <PageContainer>
      <Paper>
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={3}>
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="h2" component="div" noWrap sx={{ fontSize: { sm: '20px', lg: '24px' }, lineHeight: '28px', fontWeight: 700 }}>
              {t('page.createLicense.title')}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Box p={3}>
          <CreateLicenseForm />
        </Box>
      </Paper>
    </PageContainer>
  )
}
